import { render, staticRenderFns } from "./Debitors.vue?vue&type=template&id=4d6bbb50&"
import script from "./Debitors.vue?vue&type=script&lang=js&"
export * from "./Debitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports